import { createDecorator } from "../../instantiation/common/registry.js";
import { Emitter, Event } from "../../../base/common/events.js";
import { AIContextChangedEvent, IAIContextProvider, IAIContextService } from "./ai.js";


export class AIContextService implements IAIContextService {

    private readonly _onDidChange = new Emitter<AIContextChangedEvent>();
    readonly onDidChange = this._onDidChange.event;

    private readonly _providers: IAIContextProvider[] = [];

    registerProvider(provider: IAIContextProvider) {
        if (!this._providers.includes(provider)) {
            this._providers.push(provider);
            this._onDidChange.fire({ provider });
        }
    }

    async getProviders(): Promise<Array<IAIContextProvider> | null> {
        return this._providers.length > 0 ? this._providers : null;
    }

}